import VueCookie from "vue-cookie";
import moment from "moment";

export default {
  setToken(token, expiry) {
    return new Promise((resolve, reject) => {
      VueCookie.set("token", token, { expires: expiry });
      return resolve("cookie set");
    });
  },

  tokenIsValid() {
    let cookie = VueCookie.get("token");
    if (cookie !== null && cookie !== undefined && cookie !== "") {
      let token = this.decodeToken();
      let tokenExpiry = moment.unix(token.exp).toDate();
      let currentDate = moment().toDate();
      return moment(tokenExpiry).isAfter(currentDate) ? ((token.usupplier !== ''&& token.usupplier !== null)? true:false) : false;
    }

    return false;
  },

  decodeToken(passedToken) {
    let token =
      passedToken === undefined || passedToken === null
        ? VueCookie.get("token")
        : passedToken;
    let base64Url = token.split(".")[1];
    let base64 = base64Url.replace("-", "+").replace("_", "/");
    return JSON.parse(window.atob(base64));
  },

  logout() {
    VueCookie.delete("token");
  }
};
